import { useEffect, useState } from "react";
import { api } from "./api";

/**
 * Reads /api/config once at first call and caches it for the rest of the
 * session. Lets us flip monetization-UI on/off via the PAYMENTS_ENABLED
 * env var without a frontend rebuild.
 */
let _cached = null;
let _inflight = null;

export function useAppConfig() {
  const [config, setConfig] = useState(_cached);

  useEffect(() => {
    if (_cached) {
      setConfig(_cached);
      return;
    }
    if (!_inflight) {
      _inflight = api
        .get("/config")
        .then((r) => {
          _cached = r.data;
          return r.data;
        })
        .catch(() => {
          // Fail-safe: assume payments off when config can't be fetched.
          _cached = { payments_enabled: false };
          return _cached;
        });
    }
    _inflight.then(setConfig);
  }, []);

  return config || { payments_enabled: false };
}
